
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";
import AffidavitPersonalService from "./AffidavitPersonalService.vue";
import AboutAffiantAps from "./AboutAffiantAPS.vue";
import AboutServiceAps from "./AboutServiceAPS.vue";
import ElectronicFilingStatementAps from "./ElectronicFilingStatementAPS.vue";
import ReviewYourAnswersAps from "./reviewAPS/ReviewYourAnswersAPS.vue";
import PreviewFormsAps from "./reviewAPS/PreviewFormsAPS.vue";
import PreviewFormsApsEfsp from "./reviewAPS/PreviewFormsApsEFSP.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        AffidavitPersonalService,        
        AboutAffiantAps,
        AboutServiceAps,
        ElectronicFilingStatementAps,
        ReviewYourAnswersAps,
        PreviewFormsAps,
        PreviewFormsApsEfsp
    }
})
export default class AffidavitPersonalServiceStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
